import { Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { faSignOutAlt, faUser, faUsers } from '@fortawesome/free-solid-svg-icons';
import { Subscription } from 'rxjs';

import { AuthService } from '../../shared/services/auth.service';
import { LoggerService } from '../../shared/services/logger.service';
import { NetworkService } from '../../shared/services/network.service';
import { NotifyService } from '../../shared/services/notify.service';
import { PreferenceService } from '../../shared/services/preference.service';
import { LoginComponent } from '../login/login.component';
import { AsyncPipe } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [AsyncPipe, MatButtonModule, MatIconModule, MatMenuModule, LoginComponent, RouterLink],
})
export class HeaderComponent implements OnInit, OnDestroy {
  private authSub: Subscription;
  private onlineSub: Subscription;
  private routerSub: Subscription;
  public username: string;
  public isLoggedIn = false;
  public sticky = false;
  public acao: string;
  public faUser = faUser;
  public faUsers = faUsers;
  public faSignOutAlt = faSignOutAlt;
  public paginaInicial = true;
  public hide = true;
  public online: boolean;
  private greetingsShow = true;

  @ViewChild('menuTrigger') trigger: MatMenuTrigger;
  @ViewChild(LoginComponent) loginChild: LoginComponent;

  constructor(
    private router: Router,
    public authService: AuthService,
    public prefs: PreferenceService,
    private logger: LoggerService,
    private network: NetworkService,
    private notify: NotifyService
  ) {}

  ngOnInit() {
    this.onlineSub = this.network.online.subscribe(online => {
      this.logger.debug({ 'Header:Online': online });
      this.online = online;
    });
    this.routerSub = this.router.events.subscribe(val => {
      if (val instanceof NavigationEnd) {
        if (val.url == '/') {
          this.paginaInicial = true;
        } else {
          this.paginaInicial = false;
        }
      }
    });
    this.authSub = this.authService.user.subscribe(resUser => {
      if (resUser) {
        this.isLoggedIn = true;
        this.username = resUser.email;
        this.logger.debug({ 'Header:email:': resUser.email });
        this.prefs.items.subscribe(resPref => {
          if (resPref && resPref.name) {
            this.logger.debug({ 'Header:user:': resPref.name });
            this.username = resPref.name;
            if (this.greetingsShow) {
              this.greetingsShow = false;
              this.notify.showFastInfo(`Bem-vindo, ${this.username}`);
            }
          }
        });
      } else {
        this.username = '';
        this.greetingsShow = true;
        this.isLoggedIn = false;
      }
    });
  }

  ngOnDestroy(): void {
    if (this.authSub) {
      this.logger.debug('Header:UnSub:Auth');
      this.authSub.unsubscribe();
    }
    if (this.onlineSub) {
      this.onlineSub.unsubscribe();
    }
    if (this.routerSub) {
      this.routerSub.unsubscribe();
    }
  }

  @HostListener('window:scroll')
  handleScroll() {
    const windowScroll = window.scrollY;
    if (this.paginaInicial === true) {
      // Na página inicial mostrar a barra presa no topo mais embaixo
      this.sticky = windowScroll > 270 ? true : false;
    } else {
      this.sticky = windowScroll > 50 ? true : false;
    }
  }

  public scroll(el: HTMLElement): void {
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }
  }

  login() {
    this.loginChild.openLogin();
  }

  register() {
    this.loginChild.openRegister();
  }

  logout() {
    this.notify.showFastInfo(`Até a próxima, ${this.username}`);
    this.authService.logout().catch(err => this.logger.error(err));
  }

  public closeUserMenu(menu) {
    this.trigger.closeMenu();
  }
}
